import * as redux from 'redux';
import * as accountReducers from '../reducers/accountReducer';
import * as classroomReducers from '../reducers/classroomReducer';
import * as bookReducers from '../reducers/bookReducer';
import * as schoolReducers from '../reducers/schoolReducer';
import * as messageAlertReducer from '../reducers/messageAlertReducer';
import * as routeReducer from '../reducers/routeReducer';
import * as groupReducer from '../reducers/groupReducer';
import * as componentReducer from '../reducers/componentReducer';
import * as connectionReducer from '../reducers/connectionReducer';
import * as drawerReducer from '../reducers/drawerReducer';
import * as contentReducer from '../reducers/contentReducer';
import * as libraryReducer from '../reducers/libraryReducer';
import * as themeReducer from '../reducers/themeReducer';
import * as assignmentsDrawerReducer from '../reducers/assignmentsDrawerReducer';
import * as discussionsDrawerReducer from '../reducers/discussionsDrawerReducer';
import * as googleClassroomReducer from '../reducers/googleClassroomReducer';
import * as revealsReducer from '../reducers/revealsReducer';
import * as taskReducer from '../reducers/taskReducer';
import * as discussionReducer from '../reducers/discussionReducer';
import * as basicAnalyticsReducer from '../reducers/basicAnalyticsReducer';
import * as gradebookReducer from '../reducers/gradebookReducer';
import * as errorReducer from '../reducers/errorReducer';
import * as searchResultReducer from '../reducers/searchResultReducer';
import * as cookiesReducer from '../reducers/cookiesReducer';
import * as guestReducer from '../reducers/guestReducer';
import { userIdStorageHandler } from '../shared';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import mySaga from '../sagas/sagasLibrary';
import { i18nReducer, syncTranslationWithStore } from 'react-redux-i18n-lite';
import { REDUCER } from '../reducers/reducersConst';
import { isElectronApp } from '../services/crossPlatform/crossPlatformService';

export let configureStore = (initialState = {}) => {
  const sagaMiddleware = createSagaMiddleware();

  let appReducer = redux.combineReducers({
    ...accountReducers,
    ...classroomReducers,
    ...componentReducer,
    ...groupReducer,
    ...bookReducers,
    ...schoolReducers,
    ...messageAlertReducer,
    ...routeReducer,
    ...connectionReducer,
    ...drawerReducer,
    ...libraryReducer,
    ...contentReducer,
    ...themeReducer,
    ...revealsReducer,
    ...assignmentsDrawerReducer,
    ...discussionsDrawerReducer,
    ...taskReducer,
    ...discussionReducer,
    ...basicAnalyticsReducer,
    ...gradebookReducer,
    ...errorReducer,
    ...searchResultReducer,
    ...cookiesReducer,
    ...googleClassroomReducer,
    ...guestReducer,
    i18n: i18nReducer
  });

  let reducer = (state, action) => {
    if (action.type === 'ACCOUNT_LOGOUT' && isElectronApp()) {
      userIdStorageHandler();
      state = undefined;
    }
    return appReducer(state, action);
  };
  let store = redux.createStore(
    reducer,
    initialState,
    redux.compose(
      redux.applyMiddleware(thunk),
      redux.applyMiddleware(sagaMiddleware),
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    )
  );

  syncTranslationWithStore(store);
  sagaMiddleware.run(mySaga);
  return store;
};
